import { render } from "./TheLoaiTuyenDuong.vue?vue&type=template&id=9aee86e2"
import script from "./TheLoaiTuyenDuong.vue?vue&type=script&lang=js"
export * from "./TheLoaiTuyenDuong.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__